export const DEEP_DIVE_AMOUNT = '$50';
export const DEEP_DIVE_PRICE = `${DEEP_DIVE_AMOUNT} per book, per language`;
export const DEEP_DIVE_VALUE = '$75';
export const DEEP_DIVE_LINKS = [
  { label: 'Learn about the Deep Dive', href: 'https://www.app.novelpublicity.com/global-deepdive' },
  { label: 'View German sample', href: 'https://www.app.novelpublicity.com/global-sample-de-deepdive' },
];
export const DEEP_DIVE_EXTRAS = [
  { title: 'English meanings beside localized copy', description: 'Every blurb, tagline, headline, ad, keyword, and SEO block includes its English meaning so you can review copy in a language you do not read.' },
  { title: 'Exclusive excerpt library', description: 'Excerpts from your translated manuscript with English summaries explaining where each scene begins and ends, what it covers, and why it was selected.' },
  { title: 'AI art brief', description: 'Ten paste-ready image prompts: six built around ad angles and four for social images.' },
];
